import { Button, Typography } from "@mui/material";
import styles from "../../styles/modal.module.css";
import { useTranslation } from "react-i18next";
interface IProps {
  onClose: () => void;
  actions: {
    continue: () => void;
  };
}

const OnExitModal = ({ onClose, actions }: IProps) => {
  const {t} = useTranslation();

  /*
   * Dismissing the dialog is the dialog's own business.
   *
   * Confirming used to call actions.continue alone, and every caller holds its own
   * open flag that nothing then cleared — so the journey ended underneath but the
   * overlay stayed put, over the landing page it had just navigated to. Closing
   * here fixes both callers at once, and closing first means the overlay goes
   * whatever the action does afterwards.
   */
  const handleConfirm = () => {
    onClose();
    actions.continue();
  };
  return (
    <div className={styles.exitModalContent}>
      <div onClick={onClose} title="Close">
        <img src="/assets/cross.png" className={styles.crossWrap} />
      </div>
      <div className={styles.exitModalTitle}>
        {t('onexitmodal.title')}
      </div>
      <div className={styles.exitModalBody}>
        <Typography
          variant="body1"
          sx={{
            fontSize: "14px",
            color: "#333",
          }}
        >
          {t('onexitmodal.description')}
        </Typography>
        <div className={styles.buttonsContainer}>
          <Button
            onClick={onClose}
            sx={{
              backgroundColor: "#fff",
              color: "var(--color-primary)",
              borderRadius: "4px",
              padding: "10px 32px",
              fontSize: "14px",
              fontWeight: "normal",
              textTransform: "none",
              border: "1px solid var(--color-primary)",
              "&:hover": {
                backgroundColor: "var(--color-primary-wash)",
              },
            }}
          >
            {t('button.cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            sx={{
              backgroundColor: "var(--color-primary)",
              color: "white",
              borderRadius: "4px",
              padding: "10px 32px",
              fontSize: "14px",
              fontWeight: "normal",
              textTransform: "none",
              border: "1px solid var(--color-primary)",
              "&:hover": {
                backgroundColor: "var(--color-primary-hover)",
              },
            }}
          >
            {t('button.exit')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnExitModal;
